import React, { useEffect, useState } from "react";
import { api, getToken } from "../../../../services/apis/auth-api/apiUrl";
import { GET_USERS_BY_DEPARTMENT_END_POINT } from "../../../../config/config";
import { usersByDepartmentProps } from "../../../../utils/types";
import { AxiosError } from "axios";

interface departmentMemberProps {
    id : number,
    dep_name : string
}

const DepartmentMembers : React.FC<departmentMemberProps> = ({id, dep_name}) => {
    
    const [users, setUsers] = useState<usersByDepartmentProps[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [errorMsg, setErrorMsg] = useState({
        error : false,
        msg : ''
    });

    useEffect(()=> {
        const getDepartmentMembers = async() => {
            try{
                const usersData = await api.get(GET_USERS_BY_DEPARTMENT_END_POINT+id, {
                    headers : {'Authorization' : 'Bearer '+getToken()}
                })
                setUsers(usersData.data);
                setLoading(false);
            }catch(e){
                const error = (e as AxiosError);
                if(error.response?.status === 401) {
                    setErrorMsg({
                        error : true, 
                        msg : 'Unauthorized access.'
                    })
                }else{
                    setErrorMsg({
                        error : true, 
                        msg : 'An error occured.'
                    })
                }
                setLoading(false);
            }
        }
        getDepartmentMembers();
    },[id]);

    return (
        <div className="min-w-[34rem]">
            <div className="mb-2">
                {dep_name}'s Member/s
            </div>
            <div className="text-red-500">
                {errorMsg.msg}
            </div>
            <div className="table-container max-h-[43rem]">
                <table className="w-full border bg-transparent">
                    <thead className="table-fixed-header border">
                        <tr>
                            <th className="table-headers">#</th>
                            <th className="table-headers">Full Name</th>
                            <th className="table-headers">Email</th>
                        </tr>
                    </thead>
                    <tbody className="text-center">
                        {loading ? (
                            <>
                                <tr>
                                    <td className="table-body"><div className="table-loading"></div></td>
                                </tr>
                                <tr>
                                    <td className="table-body"><div className="table-loading"></div></td>
                                </tr>                            
                            </>
                        ) : (
                            <>
                                {users.length > 0 ? (
                                    <>
                                        {users.map((x, index) => ( 
                                            <tr>
                                                <td className="table-body">
                                                    {index + 1}
                                                </td>
                                                <td className="table-body">
                                                    {x.first_name} {x.last_name}
                                                </td>
                                                <td className="table-body">
                                                    {x.email}
                                                </td>
                                            </tr>
                                        ))}
                                    </>
                                ) : (
                                    <>
                                        <tr>
                                            <td colSpan={3} className="table-body">
                                                No user found.
                                            </td>
                                        </tr>
                                    </>
                                )}
                            </>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default DepartmentMembers;